'use client'

import { ITimeQuote } from '@repo/sdk'
import { FormControl, FormField, FormItem, FormMessage, TimeInput } from '@repo/ui/components'

import { useDateTimeInput } from './context.tsx'

export const TimesInput = () => {
  const {
    control,
    index,
    timeState: [time, setTime],
  } = useDateTimeInput()

  return (
    <FormField
      control={control}
      name={`drops.${index}.time`}
      render={() => (
        <FormItem className={'w-full'}>
          <FormControl>
            <SelectTime onFromTimeChange={setTime} onToTimeChange={setTime} time={time} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

const SelectTime = ({
  onFromTimeChange,
  onToTimeChange,
  time,
}: {
  onFromTimeChange: (value: ITimeQuote) => void
  onToTimeChange: (value: ITimeQuote) => void
  time: ITimeQuote
}) => {
  'use memo'

  const showFromTime = time.type === 'between' || time.type === 'at'
  const showToTime = time.type === 'between' || time.type === 'by'

  return (
    <div className={'flex items-center justify-center gap-2'}>
      {showFromTime && (
        <TimeInput
          onChange={value => onFromTimeChange({ ...time, from: value })}
          value={time.from}
        />
      )}
      {showToTime && showFromTime && <span>-</span>}
      {showToTime && (
        <TimeInput onChange={value => onToTimeChange({ ...time, to: value })} value={time.to} />
      )}
    </div>
  )
}

// const SelectType = ({
//   onValueChange,
//   value: selectedValue,
// }: {
//   onValueChange: (value: string) => void
//   value?: string
// }) => {
//   'use memo'
//
//   const types = [
//     { label: 'ASAP', value: '24' }, //todo replace with asap when available
//     { label: 'At', value: 'at' },
//     { label: 'By', value: 'by' },
//     { label: 'Between', value: 'between' },
//   ]
//
//   return (
//     <ButtonGroup>
//       {types.map(({ label, value }) => (
//         <Button
//           className={cn(
//             'px-2 py-3 font-semibold dark:bg-background',
//             selectedValue === value && 'bg-gray-900 text-white dark:bg-brand-gradient',
//           )}
//           key={value}
//           onClick={() => onValueChange(value)}
//           variant={'outline'}
//         >
//           {label}
//         </Button>
//       ))}
//     </ButtonGroup>
//   )
// }
